const sizes = { S: 'Small', M: 'Medium', L: 'Large' };
const pizzaSizeString = (size) => sizes[size];
export default pizzaSizeString;
